import API from "./API.js";
import Map from "./Map.js";

class Timer {
  requets = {};
  popups;

  constructor() {
    this.popups = {}
  }

  initClock(app) {
    this.popups = app.popups;

    if(!app.isPopup || true){
      setInterval(async function (app) {
        for (const key in this.requets) {
          if (Object.hasOwnProperty.call(this.requets, key)) {
            this.requets[key].timer();

            if (Object.hasOwnProperty.call(this.popups, key)) {
              if (!this.popups[key].closed) {
                this.popups[key].postMessage({
                  name: key,
                  value: JSON.stringify(app.global[key])
                }, "*");
              }
              else {
                this.closePopup(key)
              }
            }
          }
        }
      }.bind(
        this,
        app,
      ), 1000);

      // **** //

      window.addEventListener('beforeunload', (event) => {
        this.closeApp();
      })

      window.addEventListener("onmessage", (event) => {
        if (event.origin != window.location.origin) return;

        if (
          !Object.hasOwnProperty.call(event.data, 'action') ||
          !Object.hasOwnProperty.call(event.data, 'type')
        ) {
          return;
        }

        if (event.data.type == 'closePopup') {
          this.closePopup(event.data.value);
        }
      });
    }
  }

  addRequest(name, params) {
    this.requets[name] = params
  }

  addPopup(name, url) {
    if (url === undefined) {
      url = name
    }

    this.popups[name] = window.open(
      window.location.origin + "/" + url,
      name,
      "width=1080,height=605,left=0,top=0"
    );

    // if (this.popups[name]) {
    //   this.popups[name].onclose = () => {
    //   }
    // }
  }

  closePopup(key) {
    this.popups[key].close()
    delete this.popups[key];
  }

  closeApp() {
    for (const key in this.popups) {
      if (Object.hasOwnProperty.call(this.popups, key)) {
        this.popups[key].close();
      }
    }
  }

  closeRequest(key) {
    if (Object.hasOwnProperty.call(this.requets, key)) {
      return delete this.requets[key]
    }
  }

  closeRequests() {
    this.requets = {}
  }

  getPopups() {
    return this.popups
  }

  getRequets() {
    return this.requets
  }
}

export default new Timer();
